import * as React from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, message, Carousel, Tabs, Modal, Input } from "antd";
const { TabPane } = Tabs;
import { inject, observer } from "mobx-react";

import { SessionStore, RouterStore, LocaleStore, PriceStore } from "@/stores";

import API from "@/apis";

import "./index.less";

import { pool_uuid, project, home, tempActivity, assets } from "@/config.json";
import { LangType } from "@/stores/LocaleStore";
import config from "@/configs";

import MachineProfit from "./MachineProfit";
import AppContainer from "./AppContainer";
import InfoContainer from "./InfoContainer";
import FaqContainer from "./FaqContainer";
import TrendContainer from "./TrendContainer";
import _ from "lodash";
import zhbg from "@/assets/images/bg_zh.png";
import zhbgen from "@/assets/images/bg_zh_en.png";
import zerobg from "@/assets/images/zero-banner-zh.png";
import zerobgen from "@/assets/images/zero-banner-en.png";
import bannerbg from "@/assets/images/banner-bg.png";
import bannerblock from "@/assets/images/banner-image.png";
import { loadImage } from "@/utils";
import { url } from "inspector";
import Spinner from "@/components/Spinner";
import OtherLink from "@/components/OtherLink";
import { NoticeInfo } from "@/models";
import MyIcon from "@/components/MyIcon";
import Safeguard from "@/components/Safeguard";

export interface LoginProps {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
  price: PriceStore;
}

export interface LoginState {
  login: string;
  password: string;
  sliders: Object[];
  defaultUrl: any;
  showActive: boolean;
  showNotice: boolean;
  noticeList: NoticeInfo;
}

const moreUrl =
  "https://support.mempool.com/hc/zh-cn/sections/360004150954-%E9%80%9A%E7%9F%A5%E5%85%AC%E5%91%8A";

@inject("session", "price", "router", "locale")
@observer
class Login extends React.Component<LoginProps, LoginState> {
  constructor(props) {
    super(props);
  }
  slider: any;

  state = {
    login: "",
    password: "",
    sliders: [],
    defaultUrl: "",
    showActive: true,
    showNotice: true,
    noticeList: {} as NoticeInfo,
  };

  componentDidMount() {
    const { locale } = this.props;
    this.fetchData();
    this.getArticleList();
    this.props.price.getDayEarn();
    // @/assets/exatoshi/common/cn/banner.png'
    loadImage(`${locale.getLangTypeLowerCase}/${assets.banner}`).then((asset) => {
      this.setState({
        defaultUrl: asset.default,
      });
    });
  }

  getArticleList = async () => {
    try {
      const { data } = await API.User.getArticleList({
        page: 1,
        page_size: 5,
        keyword: "",
        pool_uuid: pool_uuid,
        status: 1,
      });
      this.setState({
        noticeList: data.data[0] ? data.data[0] : { link: "", title: "" },
        showNotice: data.data.length == 0 ? false : true,
      });
    } catch (error) {}
  };

  openPage() {
    window.open(moreUrl);
  }

  jump = (link) => {
    link && window.open(`//${link}`);
  };
  jumpLink = (link) => {
    console.log(link);
    link && window.open(link);
  };
  fetchData = async () => {
    try {
      const { data } = await API.Open.getBanner({ pool_uuid, status: 1 });
      this.setState({
        sliders: data.data,
      });
    } catch (error) {
      this.setState({
        sliders: [],
      });
    }
  };

  setPassword = (e) => {
    this.setState({
      password: e.target.value,
    });
  };

  login = async () => {
    const { login, password } = this.state;
    if (login && password) {
      try {
        const { data } = await API.User.login({ login, password });
      } catch (error) {}
    }
  };

  keydown = (e) => {
    if (e.keyCode == 13) {
      this.login();
    }
  };

  goNext = () => {
    // console.log(this.slider);
    this.slider.slick.slickNext();
  };

  goPrev = () => {
    this.slider.slick.slickPrev();
  };

  render() {
    const { sliders, defaultUrl, showActive } = this.state;
    const { session, locale, price } = this.props;
    const { googleVisible } = session;
    const isSlider = !_.isEmpty(sliders);
    const token = localStorage.token;
    const isRegister =
      session.currentLoginType == "register" ? `top-${locale.getLangType.toLowerCase()}` : "top80";
    let bannerNode: React.ReactNode;
    // 0费率换banner
    const banner = {
      common: {
        bgzh: zhbg,
        bgen: zhbgen,
        link: "#",
        height: "408px",
      },
      active: {
        bgzh: zerobg,
        bgen: zerobgen,
        link: `https://contract.mempool.com/zeroRate${locale.getLangType}`,
        height: "560px",
      },
    };

    const currentBanner =
      session.inActive && tempActivity.enableZeroRate ? banner.active : banner.common;

    if (_.isEmpty(sliders)) {
      bannerNode = (
        // <div
        //   style={{
        //     cursor: "pointer",
        //     height: currentBanner.height,
        //     width: "100%",
        //     background: `url(${defaultUrl}) no-repeat center center`,
        //   }}
        //   onClick={() => this.jumpLink(currentBanner.link)}
        // ></div>
        <div className="default-banner" onClick={() => this.jumpLink(currentBanner.link)}>
          {/* <img src={bannerbg} className="banner-bg"></img> */}
          <div className="default-content">
            <div className="banner-space">
              <div className="text-content">
                <div className="banner-title">
                  {locale.get("LoginBannerTitle1")}
                  <br />
                  {locale.get("LoginBannerTitle2")}
                </div>
                <div className="banner-tip">{locale.get("LoginBannerTip")}</div>
              </div>
              <img src={bannerblock} className="banner-block"></img>
            </div>
          </div>
        </div>
      );
    } else {
      bannerNode = (
        <Carousel
          className="slider"
          autoplay={true}
          dots={false}
          ref={(dom) => (this.slider = dom)}
        >
          {sliders.map((item: any) => (
            <div key={item.id}>
              <section
                onClick={() => this.jump(item.link)}
                className="slider-item"
                style={{
                  cursor: "pointer",
                  height: currentBanner.height,
                  width: "100%",
                  background: `url(${config.origin}/down/image?name=${item.image}) no-repeat center center`,
                  backgroundSize: "cover",
                }}
              ></section>
            </div>
          ))}
        </Carousel>
      );
    }

    const nodesMap = {
      TrendContainer: (
        <div className="trend-container" key="1">
          <TrendContainer />
        </div>
      ),
      MachineProfit: (
        <div className={`miner-container ${project}-bg`} key="2">
          <MachineProfit />
        </div>
      ),
      AppContainer: (
        <div className="app-container" key="3">
          <AppContainer />
        </div>
      ),
      InfoContainer: (
        <div className="info-container" key="4">
          <InfoContainer />
        </div>
      ),
      FaqContainer: (
        <div className="faq-container" key="5">
          <FaqContainer />
        </div>
      ),
    };

    return (
      <div className="login-container">
        {/* 登录 */}
        {/* {token ? (
          <div>
            <div className="slider-container">
              {bannerNode}
              {isSlider ? (
                <section className="operations">
                  <LeftOutlined onClick={this.goNext} />
                  <RightOutlined onClick={this.goPrev} />
                </section>
              ) : (
                ""
              )}
            </div>
             {session.signed ? null : (
              <div
                className="login-notice"
                style={this.state.showNotice ? {} : { display: "none" }}
              >
                <div>
                  <MyIcon type="icon-bulletin" className="icon-notice" />
                  <a
                    className="login-notice-news"
                    target="_blank"
                    href={
                      locale.getLangType == LangType.ZH
                        ? this.state.noticeList.link
                        : this.state.noticeList.en_link
                    }
                  >
                    {locale.getLangType == LangType.ZH
                      ? this.state.noticeList.title
                      : this.state.noticeList.en_title}
                  </a>
                </div>
                <div onClick={this.openPage}>
                  <span style={{ cursor: "pointer" }}>{locale.get("Header.More")}</span>
                  <MyIcon type="iconxiangzuo" className={"icon-right"} />
                </div>
              </div>
            )} 
            {session.inActive &&
            tempActivity.enableNotice &&
            localStorage.getItem("showNotice") != "no" ? (
              <OtherLink
                visible={showActive}
                onCloseModal={() => {
                  this.setState({ showActive: false });
                  localStorage.setItem("showNotice", "no");
                }}
              />
            ) : null}
            {home.arrangement.map((node) => nodesMap[node])}
          </div>
        ) : (
          <Safeguard />
        )} */}
        <Safeguard />
        {/* 某次活动 */}
        {session.inActive &&
        tempActivity.enableNotice &&
        localStorage.getItem("showNotice") != "no" ? (
          <OtherLink
            visible={showActive}
            onCloseModal={() => {
              this.setState({ showActive: false });
              localStorage.setItem("showNotice", "no");
            }}
          />
        ) : null}
      </div>
    );
  }
}

export default Login as React.ComponentType;
